import { onMounted, watch, onUnmounted, nextTick } from 'vue-demi';
export var useAttach = function (target) {
    watch(target, function (v, old, onInvalidate) {
        if (v && v !== old) {
            old === null || old === void 0 ? void 0 : old.onUnmount();
            nextTick(function () { return v.onMount(); });
            onInvalidate(function () { return v.onUnmount(); });
        }
    });
    onMounted(function () {
        var _a;
        (_a = target.value) === null || _a === void 0 ? void 0 : _a.onMount();
    });
    onUnmounted(function () {
        var _a;
        (_a = target.value) === null || _a === void 0 ? void 0 : _a.onUnmount();
    });
    return target;
};
//# sourceMappingURL=useAttach.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/hooks/useAttach.js
// module id = null
// module chunks = 